import { createSlice } from "@reduxjs/toolkit";

import { fetchBunkerFreshWaterDetailData } from "../thunks/bunkerFreshWaterDetailThunk";

import type { BunkerFreshWaterDetail } from "../../utils/types/bunkerFreshWater";

interface CargoState {
  bunkerDetail: BunkerFreshWaterDetail | null;
  loading: boolean;
  error: string | null;
}

const initialState: CargoState = {
  bunkerDetail: null,
  loading: false,
  error: null,
};

const bunkerFreshWaterDetailSlice = createSlice({
  name: "bunkerDetail",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchBunkerFreshWaterDetailData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchBunkerFreshWaterDetailData.fulfilled, (state, action) => {
        state.loading = false;
        state.bunkerDetail = action.payload?.data; // Ensure correct payload structure
      })
      .addCase(fetchBunkerFreshWaterDetailData.rejected, (state) => {
        state.loading = false;
        state.error = "Something went wrong... Please try again.";
      });
  },
});

export default bunkerFreshWaterDetailSlice.reducer;
